import Model from "../Model.js";
import Transaction from "../Transaction.js";

/**
 * A `businessActivityEvent` is a an event this impacted the
 * business/result side of the company (transaction with type).
 *
 * @param {string} spec.type - Business period group type of the event (e.g., 'Costs', 'Income').
 * @param {transaction} spec.transaction - A transaction associated with the event.
 * @param {Renderable} spec.groupName - The renderable type name translated to the user language.
 */
export default class BusinessActivityEvent extends Model {
	constructor({ type, transaction, groupName } = {}) {
		super(...arguments);
		this._type = type;
		this._transaction = transaction;
		this._groupName = groupName;
	}

	getType() {
		return this._type;
	}

	getGroupName() {
		return this._groupName;
	}

	getTransaction() {
		return this._transaction;
	}

	getAmount() {
		return this._transaction.getAmount();
	}

	getTransactionText() {
		return this._transaction.getTextOrLedgerEntryText() || "";
	}

	getDate() {
		return this._transaction.getDate();
	}

	getTransactionId() {
		return this.getLedgerEntry().getUniqueIdentifier();
	}

	getFiscalYearId() {
		return this.getLedgerEntry().getFiscalYearId();
	}

	getAccountNumber() {
		return this._getAccount().getNumber();
	}

	getAccountName() {
		return this._getAccount().getName();
	}

	getLedgerEntry() {
		return this._transaction.getLedgerEntry();
	}

	_getAccount() {
		return this._transaction.getAccount();
	}

	static transformMaterializationData(data) {
		data.transaction = new Transaction(data.transaction);
	}
}
